import React from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '../../../store'
import { createTemplate } from '../../../store/templates/actions'
import { IStore } from '../../../store/types'
import { TamplateForm } from '../../../components/Templates/TamplateForm'

export const OnlineCreateTamplate: React.FC = () => {
  const { templates, products } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  const handleCreate = (
    values: { group_id?: number; product_id: number; message: string },
    callback: (success: boolean) => void
  ) => {
    if (!values.group_id) return callback(false)
    dispatch(
      createTemplate({
        group_id: values.group_id,
        message: values.message,
        product_id: values.product_id,
      })
    ).then((res) => {
      if (res.meta.requestStatus !== 'fulfilled') {
        callback(false)
      } else {
        callback(true)
      }
    })
  }

  if (!templates.currentGroup) return null

  return (
    <TamplateForm
      title={'Створити шаблон'}
      groupId={templates.currentGroup.absnum}
      products={products.products}
      createTemplate={handleCreate}
    />
  )
}
